import { BaseEntity } from '../../../../../models';
import { Cliente } from '../../../../pessoa/cliente';

export class CampanhaCliente implements BaseEntity {
    readonly id: number;
    idCampanha: number;
    idCliente: number;
    cliente: Cliente;
}
